import { createAction } from '@reduxjs/toolkit';
import eventProvider from '../../event/eventProvider';
/* eslint-disable no-unused-vars */
enum ActionType {
  REMOTE_REQUEST_TASK_EMERGENCY_STOP = 'REMOTE_REQUEST_TASK_EMERGENCY_STOP',
  REMOTE_REQUEST_TASK_RECOVERY = 'REMOTE_REQUEST_TASK_RECOVERY',
  REMOTE_REQUEST_TASK_REMOTE_RESTART = 'REMOTE_REQUEST_TASK_REMOTE_RESTART',
  REMOTE_REQUEST_TASK_REMOTE_CONTROL = 'REMOTE_REQUEST_TASK_REMOTE_CONTROL',
  REMOTE_REQUEST_TASK_AS_ARRIVED = 'REMOTE_REQUEST_TASK_AS_ARRIVED',
  REMOTE_REQUEST_TASK_RETURN = 'REMOTE_REQUEST_TASK_RETURN',
  QUIR_REMOTE_CONTROL = 'QUIR_REMOTE_CONTROL',
  // REMOTE_REQUEST_RESET_ABNORMAL_CONTROL = 'REMOTE_REQUEST_RESET_ABNORMAL_CONTROL',
  CLEAR_STORE_CONTROL_RESPONSE = 'CLEAR_STORE_CONTROL_RESPONSE',
  JIRA_ISSUE = 'JIRA_ISSUE',
  REPEAT_VERIFICATION_CODE = 'REPEAT_VERIFICATION_CODE',
  UPLOAD_ASSIST_JIRA_ATTACHMENT = 'UPLOAD_ASSIST_JIRA_ATTACHMENT',
  REMOTE_CONTROL_REQUEST_VEHICLE = 'REMOTE_CONTROL_REQUEST_VEHICLE',
  REMOTE_CONTROL_REQUEST_VEHICLE_DELAY = 'REMOTE_CONTROL_REQUEST_VEHICLE_DELAY',
  REMOTE_REQUEST_TASK_PASS_LIGHT = 'REMOTE_REQUEST_TASK_PASS_LIGHT',

  REMOTE_REQUEST_EMERGENCY_STOP = 'REMOTE_REQUEST_EMERGENCY_STOP', // 急停指令
  REMOTE_REQUEST_RECOVERY = 'REMOTE_REQUEST_RECOVERY', // 恢复指令
  REMOTE_REQUEST_REMOTE_RESTART = 'REMOTE_REQUEST_REMOTE_RESTART', // 重启指令
  REMOTE_REQUEST_REMOTE_CONTROL = 'REMOTE_REQUEST_REMOTE_CONTROL', // 遥控指令
  REMOTE_REQUEST_REMOTE_SUPER_CONTROL = 'REMOTE_REQUEST_REMOTE_SUPER_CONTROL', // 超级遥控指令
  REMOTE_REQUEST_RESET_ABNORMAL_CONTROL = 'REMOTE_REQUEST_RESET_ABNORMAL_CONTROL', // 异常恢复指令
  REMOTE_REQUEST_PASS_LIGHT = 'REMOTE_REQUEST_PASS_LIGHT', // 一键通过红绿灯
  REMOTE_REQUEST_CANCEL_LIGHT = 'REMOTE_REQUEST_CANCEL_LIGHT', // 取消通过红绿灯
  REMOTE_REQUEST_AS_ARRIVED = 'REMOTE_REQUEST_AS_ARRIVED', // 视同到达指令
  REMOTE_REQUEST_QUIT_CONTROL = 'REMOTE_REQUEST_QUIT_CONTROL', // 退出远程遥控操作
  REMOTE_REQUEST_RETURN = 'REMOTE_REQUEST_RETURN', // 返程指令
  REMOTE_REQUEST_USER_CONTROL = 'REMOTE_REQUEST_USER_CONTROL', // 记录用户操作指令
  REMOTE_CONTROL_POWER_REBOOT = 'REMOTE_CONTROL_POWER_REBOOT', // 断电重启指令反馈
  REMOTE_CONTROL_POWER_OFF = 'REMOTE_CONTROL_POWER_OFF', // 远程下电指令反馈

  REMOTE_WEB_TERMINAL_TOOL = 'REMOTE_WEB_TERMINAL_TOOL', // 获取远程工具列表
  WEB_TERMINAL_COMMAND_DATA = 'WEB_TERMINAL_COMMAND_DATA', // 文件拉取和上传指令
}

export const actionEmergencyStop = createAction(
  eventProvider.makeResponseType(ActionType.REMOTE_REQUEST_TASK_EMERGENCY_STOP),
);
export const actionRecovery = createAction(
  eventProvider.makeResponseType(ActionType.REMOTE_REQUEST_TASK_RECOVERY),
);
export const actionRestart = createAction(
  eventProvider.makeResponseType(ActionType.REMOTE_REQUEST_TASK_REMOTE_RESTART),
);
export const actionRemoteControl = createAction(
  ActionType.REMOTE_REQUEST_TASK_REMOTE_CONTROL,
);

export const actionAsArrived = createAction(
  eventProvider.makeResponseType(ActionType.REMOTE_REQUEST_TASK_AS_ARRIVED),
);
export const actionReturn = createAction(
  eventProvider.makeResponseType(ActionType.REMOTE_REQUEST_TASK_RETURN),
);
export const clearControlResponse = createAction(
  ActionType.CLEAR_STORE_CONTROL_RESPONSE,
);
export const actionHandleJIRAIssue = createAction<any>(
  eventProvider.makeResponseType(ActionType.JIRA_ISSUE),
);

export const actionResentVerificationCode = createAction<any>(
  eventProvider.makeResponseType(ActionType.REPEAT_VERIFICATION_CODE),
);

export const actionRemoteControlResponse = createAction<any>(
  eventProvider.makeResponseType(
    ActionType.REMOTE_CONTROL_REQUEST_VEHICLE_DELAY,
  ),
);

export const actionPassTrafficLight = createAction<any>(
  eventProvider.makeResponseType(ActionType.REMOTE_REQUEST_TASK_PASS_LIGHT),
);

export default ActionType;
